<div
  class="d-flex align-items-center gap-1 copy-cell"
  (mouseenter)="handleHover('name')"
  (mouseleave)="handleHover('name')"
>
  @if (showSearchResultIcon()) {
    <div
      class="result-image"
      [ngClass]="{ 'round-image-table': !customIcon() || customIcon() !== ziroIcons.CALL_QUEUE }"
      data-automation="microsoft-search-result-photo"
    >
      @if (isPhotoLoading() && !photo()) {
        <ngx-skeleton-loader
          data-automation="microsoft-search-result-photo-skeleton"
          count="1"
          appearance="circle"
          [theme]="{ width: '24px', height: '24px', margin: '0' }"
        ></ngx-skeleton-loader>
      } @else if (photo()) {
        <img [src]="'data:image/png;base64,' + photo()" data-automation="microsoft-search-result-image" />
      } @else if (initials()) {
        <div class="search-result-initials" data-automation="microsoft-search-result-initials">
          {{ initials() }}
        </div>
      } @else {
        <i
          class="fa font-size-24"
          [ngClass]="customIcon() || ziroIcons.CIRCLE_USER"
          data-automation="microsoft-search-result-icon"
        ></i>
      }
    </div>
  }

  <span [disableTooltip]="(result()?.displayName?.length || 0) <= charLimitDN" [ngbTooltip]="result()?.displayName">
    @if (showSubLabel()) {
      <span data-automation="microsoft-search-result-display-name-sublabel" class="d-block text-start font-size-14">
        {{ subLabel() }}
      </span>
    }
    <strong data-automation="microsoft-search-result-display-name" class="text-start font-size-14">
      {{ result()?.displayName | trimWithEllipsisFilter: charLimitDN }}
    </strong>
  </span>
  <button
    [ngbTooltip]="copyTooltip"
    #t="ngbTooltip"
    [triggers]="'click'"
    (click)="handleCopy($event, t)"
    [cdkCopyToClipboard]="result().displayName"
    class="ms-2 copy-icon"
  >
    <i [class]="ziroIcons.COPY"></i>
  </button>
</div>
<div
  class="d-flex align-items-center copy-cell font-size-14"
  data-automation="microsoft-search-result-upn"
  (mouseenter)="handleHover('upn')"
  (mouseleave)="handleHover('upn')"
>
  @if (showUpn()) {
    <div [disableTooltip]="result().id.length <= charLimitUpn()" [ngbTooltip]="result().id">
      {{ result().id | trimWithEllipsisFilter: charLimitUpn() }}
    </div>
    <button
      [ngbTooltip]="copyTooltip"
      #t="ngbTooltip"
      [triggers]="'click'"
      (click)="handleCopy($event, t)"
      [cdkCopyToClipboard]="result().id"
      class="ms-2 copy-icon"
    >
      <i [class]="ziroIcons.COPY"></i>
    </button>
  }
</div>
@if (!hideAssignedNumberCol()) {
  <div
    class="d-flex align-items-center copy-cell font-size-14"
    data-automation="microsoft-search-result-assigned-number"
    (mouseenter)="handleHover('number')"
    (mouseleave)="handleHover('number')"
  >
    @if (!isLoadingLineUri()) {
      <span>{{ formatLineUri(lineUri(), lineUriExtension()) }}</span>
      @if (lineUri() || lineUriExtension()) {
        <button
          [ngbTooltip]="copyTooltip"
          #t="ngbTooltip"
          [triggers]="'click'"
          (click)="handleCopy($event, t)"
          [cdkCopyToClipboard]="calcNumberCopyValue()"
          class="ms-2 copy-icon"
        >
          <i [class]="ziroIcons.COPY"></i>
        </button>
      }
    }
  </div>
}
<div class="d-flex align-items-center">
  <ziro-button
    [buttonSize]="ButtonSizes.XSMALL"
    [buttonStyle]="ButtonStyles.OUTLINE_PRIMARY"
    [dataAutomation]="'microsoft-search-result-button'"
    [icon]="ziroIcons.EDIT"
    [isDisabled]="isDisabled()"
    [isTooltipDisabled]="!isDisabled()"
    [tooltip]="disabledTooltip()"
  ></ziro-button>
</div>
